<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-6">
                        <div class="font-weight-bold body-1">
                            Editar extraordinario
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <extraordinary-form ref="ExtraordinaryForm" :values="form" @save="save" :serverErrors="serverErrors"></extraordinary-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Object2Form from '../../../helpers/Object2Form';
import Utils from '../../../helpers/Utils';
import ExtraordinaryForm from "./Form.vue";
export default {
    components: {
        'extraordinary-form': ExtraordinaryForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            slug: this.$route.params.slug,
            form: {
                customs_agent_id: "",
                customer_id: "",
                traffic_number: "",
                payment_date: "",
                // account_id: "",
                bank_account_id: "",
                amount: "",
                concept_id: "", //concepto

                support_file: [],
                support_file_url: ""
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Extraordinaries",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.extraordinary.get(this.$store.state.business, this.slug)
                .then((resp) => {
                    this.form = {...resp.data};
                    this.form.customs_agent_id = resp.data.customs_agent.slug;
                    this.form.customer_id = resp.data.customer.slug;
                    // this.form.account_id = resp.data.account.slug;
                    this.form.bank_account_id = resp.data.bank_account.slug;
                    this.form.concept_id = resp.data?.concept?.slug;

                    this.form.support_file = [];
                    this.form. support_file_url = resp.data.support_file_url;

                    console.log(this.form);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.extraordinary.update(this.$store.state.business,this.slug, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Extraordinaries'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },


        prepareRequest(request)
        {
            
            let data = JSON.parse(JSON.stringify(request));
            
            data.support_file = request.support_file;

            if(request.support_file_url == '' && (request.support_file instanceof Array))
                data.support_file = null;

            if(request.support_file_url != '' && (request.support_file instanceof Array))
                delete data.support_file;

            return Object2Form.objectToFormData(data,'',[]);
        }

        
    },
}
</script>

<style>

</style>